export const INIT = 'INIT';
export const LOADING = 'LOADING';
export const CHANGE_SEARCH = 'CHANGE_SEARCH';
export const CHANGE_SEARCH_OPTION = 'CHANGE_SEARCH_OPTION';
export const CHANGE_FILTER_STATUS = 'CHANGE_FILTER_STATUS';
export const CHANGE_FILTER_TYPE = 'CHANGE_FILTER_TYPE';
export const CHANGE_FILTER_SUBCATEGORY = 'CHANGE_FILTER_SUBCATEGORY';
export const CHANGE_FILTER_PROVIDER = 'CHANGE_FILTER_PROVIDER';
export const SHOW_CATEGORY = 'SHOW_CATEGORY';
export const HIDE_CATEGORY = 'HIDE_CATEGORY';
export const TOGGLE_CATEGORIES = 'TOGGLE_CATEGORIES';
export const UPDATE_LIST = 'UPDATE_LIST';
export const UPDATE_CATEGORIES_LIST = 'UPDATE_CATEGORIES_LIST';
export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const DUPLICATE = 'DUPLICATE';
export const DELETE = 'DELETE';
export const CLEAR_HIGHLIGHT_SERVICES = 'CLEAR_HIGHLIGHT_SERVICES';
export const CLEAR_HIGHLIGHT_CATEGORIES = 'CLEAR_HIGHLIGHT_CATEGORIES';
export const CLEAR_HIGHLIGHTS = 'CLEAR_HIGHLIGHTS';
export const CHANGE_SERVICE_STATUS = 'CHANGE_SERVICE_STATUS';
export const CHANGE_SERVICE_STATUS_SUCCESS = 'CHANGE_SERVICE_STATUS_SUCCESS';
export const CHANGE_SERVICE_STATUS_ERROR = 'CHANGE_SERVICE_STATUS_ERROR';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const CATEGORY_CREATE = 'CATEGORY_CREATE';
export const CLEAR_SCROLLS = 'CLEAR_SCROLLS';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const EDIT_DESCRIPTION = 'EDIT_DESCRIPTION';
export const RESET_CUSTOM_RATE = 'RESET_CUSTOM_RATE';
export const CATEGORY_CHANGE_VISIBILITY = 'CATEGORY_CHANGE_VISIBILITY';
export const MASS_SERVICES_DELETE = 'MASS_SERVICES_DELETE';
export const SERVICES_MASS_CHANGE_STATUS = 'SERVICES_MASS_CHANGE_STATUS';
export const SERVICES_MASS_CHANGE_DRIP_FEED = 'SERVICES_MASS_CHANGE_DRIP_FEED';
export const SERVICES_MASS_ASSIGN_CATEGORY = 'SERVICES_MASS_ASSIGN_CATEGORY';
export const SERVICES_MASS_RESET_CUSTOM_RATES = 'SERVICES_MASS_RESET_CUSTOM_RATES';
export const SERVICES_CHANGE_POSITION_CATEGORY = 'SERVICES_CHANGE_POSITION_CATEGORY';
export const SERVICES_CHANGE_POSITION_CATEGORY_ERROR = 'SERVICES_CHANGE_POSITION_CATEGORY_ERROR';
export const SERVICES_CHANGE_POSITION_SERVICE = 'SERVICES_CHANGE_POSITION_SERVICE';
export const SERVICES_CHANGE_POSITION_ERROR = 'SERVICES_CHANGE_POSITION_ERROR';
export const SERVICES_UPDATE_RATE_SUCCESS = 'SERVICES_UPDATE_RATE_SUCCESS';
export const SERVICES_UPDATE_RATE_ERROR = 'SERVICES_UPDATE_RATE_ERROR';
export const SERVICES_EDIT_SUCCESS = 'SERVICES_EDIT_SUCCESS';
export const IMPORT_SERVICES = 'IMPORT_SERVICES';
export const CHANGE_START = 'CHANGE_START';
